<template>
    <div class="footer-wrapper">
        <b-card
                header=""
                header-text-variant="white"
                header-tag="header"
                header-bg-variant="dark"
                footer="© 2020 webcapsule"
                footer-tag="footer"
                footer-bg-variant="dark"
                footer-border-variant="dark"
                title=""
                style="min-width: 100vw"
                id="footer-body"
        >
            <div class="link-styler">
                <div style="display: flex; flex-direction: column; float: left; padding-left: 15px">
                    <b-link class="link">About</b-link>
                    <b-link class="link">Impressum</b-link>
                    <b-link class="link">Disclaimer</b-link>
                    <b-link class="link">Datenschutzerklärung</b-link>
                </div>
                <div style="display: flex; flex-direction: column; float: right;">
                    <div class="socail-icon">
                        <img class="social-icon-image" src="../assets/instagram.png" alt="insta-icon"/>
                    </div>
                    <div @click=this.goToTwitter class="socail-icon">
                        <img class="social-icon-image" src="../assets/twitter.png" alt="twitter-icon"/>
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: 'Footer',
        methods: {
            goToTwitter() {
              window.location = 'https://twitter.com/webcapsule1';
            },
        },
    };
</script>

<style>
    .footer-wrapper {
        background: linear-gradient(to left, black, #202020);
        color: white;
        height: auto;
        width: 100vw;
        margin-top: 50px;
    }

    .footer-wrapper p {
        padding: 0;
        margin: 0;
    }

    #footer-body {
        background: transparent;
    }

    .link-styler {
        width:80vw;
        max-width: 800px;
        margin-left: auto;
        margin-right: auto;
    }

    .link {
        color: white!important;
        margin-bottom: 10px;
        text-align: left;
    }

    .socail-icon {
        height: auto;
        width: auto;
        margin-bottom: 25px;
        margin-right: 0;
        padding-right: 15px;
    }

    .social-icon-image {
        width: 50px;
        height: 50px;
    }
</style>
